module.exports = function() {
  return new Worker(__webpack_public_path__ + "393d7f236ca07cb63780.worker.js");
};